export const isNodeEnv = () => typeof window === 'undefined';
